/* RESPONSIBLE TEAM: team-standalone */

import { ChannelTargetingBodyData } from '../definitions';

export default class FreshdeskLegacyChannelTargetingBodyData extends ChannelTargetingBodyData {
  get addMessengerChannel() {
    return true;
  }

  get channelGroupTitleKey() {
    return 'operator.workflows.channels.groupings.freshdesk-legacy';
  }

  get channels(): ChannelTargetingBodyData['channels'] {
    return [];
  }
}
